import formatsIndex from './index'
import keirekishoFormatsIndex from './keirekisho_index'
import rirekishoFormatsIndex from './rirekisho_index'
import yagiofferFormatsIndex from './yagioffer_index'
import etcFormatsIndex from './etc_index'
export default (id) => {
  const formatDetail = formatsIndex.find(function (format) {
    return format.id === id
  })
  const keirekishoFormatsDetail = keirekishoFormatsIndex.find(function (format) {
    return format.id === id
  })
  const rirekishoFormatsDetail = rirekishoFormatsIndex.find(function (format) {
    return format.id === id
  })
  const yagiofferFormatsDetail = yagiofferFormatsIndex.find(function (format) {
    return format.id === id
  })
  const etcFormatsDetail = etcFormatsIndex.find(function (format) {
    return format.id === id
  })
  if (formatDetail) {
    return formatDetail
  } else if (keirekishoFormatsDetail) {
    return keirekishoFormatsDetail
  } else if (rirekishoFormatsDetail) {
    return rirekishoFormatsDetail
  } else if (yagiofferFormatsDetail) {
    return yagiofferFormatsDetail
  } else if (etcFormatsDetail) {
    return etcFormatsDetail
  }
  return formatDetail

  if (!formatDetail) {
    return keirekishoFormatsIndex.find(function (format) {
      return format.id === id
    })
  } else {
    if (!formatDetail) {
      return yagiofferFormatsIndex.find(function (format) {
        return format.id === id
      })
    } else {
      if (!formatDetail) {
        return yagiofferFormatsIndex.find(function (format) {
          return format.id === id
        })
      } else {
        return formatDetail
      }
    }
  }
}
